// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    STATIC_PAGE_LOADING() {
      return {
        isLoading: true,
        staticPage: action.staticPage
      };
    },
    STATIC_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.staticPage
      };
    },
    STATIC_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.staticPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
